namespace GeniuzPOS.AdvPromo {
    export namespace Adv05ItemDetailsService {
        export const baseUrl = 'AdvPromo/Adv05ItemDetails';

        export declare function Create(request: Serenity.SaveRequest<Adv05ItemDetailsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<Adv05ItemDetailsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<Adv05ItemDetailsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<Adv05ItemDetailsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "AdvPromo/Adv05ItemDetails/Create",
            Update = "AdvPromo/Adv05ItemDetails/Update",
            Delete = "AdvPromo/Adv05ItemDetails/Delete",
            Retrieve = "AdvPromo/Adv05ItemDetails/Retrieve",
            List = "AdvPromo/Adv05ItemDetails/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>Adv05ItemDetailsService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
